import { grey } from "@mui/material/colors"
import { Box, Button, Stack, Typography, Divider, CircularProgress } from "@mui/material"
import Image from "next/image"
import MainCard from "../../common/main-card"
import { alpha } from "@mui/material"
import { convertToPersianDate } from "../../../utils/ConvertToPersianDate"
import clubServices from "../../../services/club"
import { useState } from "react"
import { toast } from "react-toastify"

const PackageCard = ({ packageItem, handlePlanModal, handleDetail, setItemSelected }) => {
  const { packageId, file, name, isActive, code, expiredDate } = packageItem
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleSelectPlan = () => {
    setLoading(true)
    clubServices
      .clubInsertUserPackage(packageId)
      .then(response => {
        if (response?.status === 200) {
          setLoading(false)
          if (!response?.data?.value) {
            setError(response?.data?.message)
            toast.error(response?.data?.message)
          } else {
            handleDetail({ code: response.data.value.code, expiredDate: response.data.value.expiredDate })
            handlePlanModal()
            setItemSelected(packageId)
            toast.success("طرح شما با موفقیت ثبت شد")
          }
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <MainCard
      shadow={0}
      sx={{
        py: 2,
        border: 3,
        borderColor: alpha(grey[200], 0.7),
        mb: 2
      }}
    >
      <Stack>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            p: 1,
            border: 1,
            borderRadius: "3px",
            gap: 0.5,
            borderColor: alpha(grey[200], 0.7)
          }}
        >
          {file ? (
            <Box
              sx={{
                border: 1,
                width: 50,
                height: 50,
                borderRadius: "100%",
                overflow: "hidden",
                borderColor: alpha(grey[200], 0.7)
              }}
            >
              <Image src={file} alt={name} width={50} height={50} style={{ objectFit: "cover" }} />
            </Box>
          ) : (
            <Image src={"/images/icons/shop.png"} alt={name} width={50} height={50} style={{ objectFit: "cover" }} />
          )}
          <Typography textAlign='center' fontWeight={600} ml={"1rem"}>
            {name ?? ""}
          </Typography>
        </Box>

        <Stack sx={{ mt: 1 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 1 }}>
            {code && (
              <>
                <Typography textAlign='center' fontWeight={600}>
                  کد تخفیف:
                </Typography>
                <Typography textAlign='center' fontWeight={600}>
                  {code}
                </Typography>
              </>
            )}
          </Box>

          {expiredDate && (
            <>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  p: 1,
                  minHeight: "1.8rem"
                }}
              >
                <Typography textAlign='center' fontWeight={600}>
                  تاریخ اعتبار:
                </Typography>
                <Typography textAlign='center' fontWeight={600}>
                  {convertToPersianDate(expiredDate, "jYYYY/jMM/jDD")}
                </Typography>
              </Box>
              <Divider />
            </>
          )}
        </Stack>

        <Button
          color='primary'
          variant='contained'
          size='medium'
          sx={{
            mt: 1,
            borderRadius: "8px",
            cursor: "pointer",
            border: 1
          }}
          onClick={handleSelectPlan}
          disabled={loading || !isActive}
        >
          {loading ? <CircularProgress sx={{ mx: 4, my: 0.3 }} size={25} /> : "انتخاب و دریافت"}
        </Button>
      </Stack>
    </MainCard>
  )
}

export default PackageCard
